import { Alert, Box, Button, CircularProgress, Stack } from "@mui/material";
import { FormikErrorNotification, FormikTextField } from "@shared";

import { MAIL_MERGE_TEXT_EMPHASIS } from "@/common/components/mail-merge-access/MailMergeTextEmphasis";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { Trans, useTranslation } from "@/translations";

import { useMailMergeSettings } from "./hooks/useMailMergeSettings";

function MailMergeSettingsInner() {
  const { t } = useTranslation();
  const { formik, isLoading, folderPathMaxLength } = useMailMergeSettings();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack component="form" onSubmit={formik.handleSubmit} flex="1 1 100%" overflow="hidden" gap={3} bgcolor="white">
      <FormikErrorNotification formik={formik} />

      <Stack flex={1} gap={3} sx={{ overflowY: "auto", pr: 1 }}>
        <Alert severity="info">
          <Trans i18nKey="settings.mailMerge.description" components={MAIL_MERGE_TEXT_EMPHASIS} />
        </Alert>

        <FormikTextField
          formik={formik}
          fieldName="dataSourceFolder"
          label={t("settings.mailMerge.dataSourceFolder")}
          required
          slotProps={{ input: { inputProps: { maxLength: folderPathMaxLength } } }}
        />
      </Stack>

      <Stack direction="row" justifyContent="space-between" p={0.5} pb={2}>
        <Button variant="outlined" onClick={formik.handleReset} disabled={formik.isSubmitting || !formik.dirty}>
          {t("common.resetChanges")}
        </Button>
        <Button variant="contained" type="submit" disabled={formik.isSubmitting || !formik.dirty}>
          {t("common.save")}
        </Button>
      </Stack>
    </Stack>
  );
}

export const MailMergeSettings = withAuthorization(MailMergeSettingsInner, UserPermission.Supervisor);
